import { render, staticRenderFns } from "./ConfectionRowForm.vue?vue&type=template&id=35131b9e&scoped=true&"
import script from "./ConfectionRowForm.vue?vue&type=script&lang=js&"
export * from "./ConfectionRowForm.vue?vue&type=script&lang=js&"
import style0 from "./ConfectionRowForm.vue?vue&type=style&index=0&id=35131b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35131b9e",
  null
  
)

export default component.exports